import * as types from './types'

export function screenResize(width) {
  return {
      type: types.SCREEN_RESIZE,
      screenWidth: width
  };
}

export function setDesktopView(){
  return{
    type: types.SWIPER_STATE,
    swiperActive: false
  }
}

export function setMobileView(){
  return{
    type: types.SWIPER_STATE,
    swiperActive: true
  }
}